<div>
  @if (title) {
    <div class="my-2">
      <div class="row">
        <div class="col">
          <ion-label class="color-medium text-uppercase">{{ title }}</ion-label>
        </div>
      </div>
    </div>
  }

  <div class="two-choices mb-3">
    <div class="row h-100">
      <div class="col-6 h-100">
        <div
          class="row h-100 align-items-center"
          (click)="onChangePress(firstValue!)"
          [class.two-choices-selected]="value === firstValue"
        >
          <div class="col text-center">
            {{ firstLabel }}
          </div>
        </div>
      </div>
      <div class="col-6 h-100">
        <div
          class="row h-100 align-items-center"
          (click)="onChangePress(secondValue!)"
          [class.two-choices-selected]="value === secondValue"
        >
          <div class="col text-center">
            {{ secondLabel }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
